import axios from "axios";
import authHeader from '../authheader'

const BOARDCOMMENTURL = process.env.REACT_APP_APIURL + "/api/BoardMember";


const getBoardComments = (parentId, parentTypeId) => {
    return axios.get(`${BOARDCOMMENTURL}/getboardcomments`, { headers: authHeader(), params: { parentId, parentTypeId } });
}
const postBoardComment = (data) => {
    return axios.post(`${BOARDCOMMENTURL}/postboardcomments`, data, { headers: authHeader() });
}
const deleteBoardComment = (id) => {
    return axios.post(`${BOARDCOMMENTURL}/deleteboardcomment`, null, { headers: authHeader(), params: { id } });

}
export default {
    getBoardComments,
    postBoardComment,
    deleteBoardComment
}